export default __webpack_public_path__ + "static/bangles-bb184929c52cacc8c648dcef0ba0ef7f.png";